/** map */
export const mapDefault = {
	center: [29.212836499999995, 69.22237966666667],
};

export const heatmapDefault = {
	heatmapRadius: 48,
	heatmapBlur: 55,
	max: 1,
};

/**
 * marker has two type:
 * 1.point
 * 2.cluster(with many points)
 * */

export const paletteStyleDefault = 'regular';

// marker style list
export const markerPaletteStyle = [
	{ id: 'palette-style-01', color: 'regular' },
	{ id: 'palette-style-02', color: 'orange' },
];

// point palette
export const pointMarkerPalette = {
	regular: [
		{ id: 'color-regular-01', pubsRange: '0-3', color: '#C0FA6D', min: 0, max: 3 },
		{ id: 'color-regular-02', pubsRange: '4-6', color: '#e5fa6d', min: 4, max: 6 },
		{ id: 'color-regular-03', pubsRange: '7-10', color: '#fae06d', min: 7, max: 10 },
		{ id: 'color-regular-04', pubsRange: '11-15', color: '#fabf6d', min: 11, max: 15 },
		{ id: 'color-regular-05', pubsRange: '>15', color: '#fa766d', min: 16, max: 1000 },
	],
	orange: [
		{ id: 'color-orange-01', pubsRange: '0-3', color: '#e5fa6d', min: 0, max: 3 },
		{ id: 'color-orange-02', pubsRange: '4-6', color: '#EDC79B', min: 4, max: 6 },
		{ id: 'color-orange-03', pubsRange: '7-10', color: '#D57A66', min: 7, max: 10 },
		{ id: 'color-orange-04', pubsRange: '11-15', color: '#CA6680', min: 11, max: 15 },
		{ id: 'color-orange-05', pubsRange: '>15', color: '#b05487', min: 16, max: 1000 },
	],
};

// cluster palette
export const clusterMarkerColor = {
	regular: 'EED817',
	orange: '#FFBC42',
};

// layer type
export const layerType = {
	balloon: 'balloon',
	heat: 'heat',
};
